import React from "react";

import Container from "@material-ui/core/Container";
import ApplicationPanel from "../../application/ApplicationPanel";
import ApplicationHeader from "../../application/ApplicationHeader";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import IpOverrideBrowse from "./IpOverrideBrowse";
import { AlertProvider } from "../../components/alert/AlertProvider";

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: false,
      staleTime: Infinity,
    },
  },
});
const ManageIpOverrides = () => {
  return (
    <AlertProvider>
      <Container id="manage-ip-overrides" disableGutters>
        <ApplicationHeader />

        <ApplicationPanel>
          <QueryClientProvider client={queryClient}>
            <ReactQueryDevtools initialIsOpen={false} />

            <IpOverrideBrowse />
          </QueryClientProvider>
        </ApplicationPanel>
      </Container>
    </AlertProvider>
  );
};

export default ManageIpOverrides;
